import type { ClipboardPayload } from '@model-framework/clipboard';
import { type TSVClipboardPayload, isTSVClipboardPayload } from './TSVClipboardPayload';
import { type StickyModelClipboardPayload, isStickyModelClipboardPayload } from './StickyModelClipboardPayload';
import { type TextClipboardPayload, isTextClipboardPayload } from './TextClipboardPayload';
import type { ViewModelClipboardPayload } from '@view-model/application/operation/ViewModelClipboardPayload';
import { isViewModelClipboardPayload } from '@view-model/application/operation/ViewModelClipboardPayload';
import type { ViewsClipboardPayload } from './ViewsClipboardPayload';
import { isViewsClipboardPayload } from './ViewsClipboardPayload';
import type { ImageClipboardPayload } from './ImageClipboardPayload';
import { isImageClipboardPayload } from './ImageClipboardPayload';
import type { FileClipboardPayload } from './FileClipboardPayload';
import { isFileClipboardPayload } from './FileClipboardPayload';

export type ApplicationClipboardPayload =
  | ViewModelClipboardPayload
  | ViewsClipboardPayload
  | StickyModelClipboardPayload
  | TSVClipboardPayload
  | TextClipboardPayload
  | ImageClipboardPayload
  | FileClipboardPayload;

export const isApplicationClipboardPayload = (payload: ClipboardPayload): payload is ApplicationClipboardPayload =>
  isViewModelClipboardPayload(payload) ||
  isViewsClipboardPayload(payload) ||
  isStickyModelClipboardPayload(payload) ||
  isTSVClipboardPayload(payload) ||
  isTextClipboardPayload(payload) ||
  isImageClipboardPayload(payload) ||
  isFileClipboardPayload(payload);
